export function init() {
  console.log("[loaded] iframe-321med");
  const iframes = document?.querySelector(".iframe-321med");

  if (iframes) {
    document.body.classList.add("widget-321med-hidden");
  }
}

// Enum of 321med ui ids (STARVI-884)
export const UI = Object.freeze({
  ButtonAnimation: 'button_321med_animation',
  Button: 'button_321med',
  Info: 'info_321med',
  CookiebotWidget: 'CookiebotWidget',
});